import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Paperclip, Plus, X } from "@phosphor-icons/react";

export function TransitAttachments({ transit, onChanged }) {
  const [busy, setBusy] = useState(false);
  const docs = transit.documents || [];
  const upload = async (e) => {
    const files = Array.from(e.target.files || []); e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    let ok = 0;
    for (const f of files) {
      if (f.size > 15 * 1024 * 1024) { toast.error(`${f.name} is over 15 MB`); continue; }
      const fd = new FormData(); fd.append("file", f);
      try { await api.post(`/transit-shipments/${transit.id}/documents`, fd, { headers: { "Content-Type": "multipart/form-data" } }); ok += 1; }
      catch (err) { toast.error(err.response?.data?.detail || `Could not upload ${f.name}`); }
    }
    if (ok) toast.success(`${ok} file(s) attached to ${transit.number}`);
    setBusy(false); onChanged?.();
  };
  const remove = async (fid) => {
    try { await api.delete(`/transit-shipments/${transit.id}/documents/${fid}`); toast.success("Attachment removed"); onChanged?.(); } catch { toast.error("Could not remove"); }
  };
  const openDoc = async (d) => {
    try { const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/files/${d.storage_path}`, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }); window.open(URL.createObjectURL(await r.blob()), "_blank"); } catch { toast.error("Could not open file"); }
  };
  return (
    <div className="w-full flex flex-wrap items-center gap-1.5 pt-1" data-testid={`transit-attachments-${transit.id}`}>
      <span className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground flex items-center gap-1"><Paperclip size={12} /> Shipment docs</span>
      {docs.map((d) => (
        <span key={d.id} className="inline-flex items-center gap-1 rounded-sm bg-muted px-2 py-0.5 text-xs max-w-[220px]" data-testid={`transit-doc-chip-${d.id}`}>
          <button type="button" className="truncate hover:underline" onClick={() => openDoc(d)} title={d.original_filename}>{d.original_filename}</button>
          <button type="button" className="text-muted-foreground hover:text-destructive" onClick={() => remove(d.id)} title="Remove" data-testid={`transit-doc-chip-remove-${d.id}`}><X size={12} /></button>
        </span>
      ))}
      <label className={`inline-flex items-center gap-1 text-xs font-medium text-primary cursor-pointer hover:underline ${busy ? "opacity-50 pointer-events-none" : ""}`}>
        <Plus size={12} /> {busy ? "Uploading…" : docs.length ? "Add" : "Attach documents"}
        <input type="file" multiple className="hidden" accept=".pdf,.jpg,.jpeg,.png,.xlsx,.xls,.docx,.doc,.csv" onChange={upload} data-testid={`transit-attach-input-${transit.id}`} />
      </label>
    </div>
  );
}
